import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function TermsConditions() {
  return (
    <>
      <Header />
      <section className="page-header">
        <div className="container">
          <h1>Terms &amp; Conditions</h1>
          <p>Last updated: January 2024</p>
        </div>
      </section>
      <section className="legal-section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section-block">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing or using checkmycarhistory.com.au you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.</p>
            </div>

            <div className="legal-section-block">
              <h2>2. Service Description</h2>
              <p>checkmycarhistory.com.au provides access to vehicle history reports sourced from the Australian Personal Property Securities Register (PPSR) and related government databases. Our reports are provided for informational purposes only.</p>
            </div>

            <div className="legal-section-block">
              <h2>3. Pricing and Payment</h2>
              <ul>
                <li>All prices are displayed in Australian Dollars (AUD) and are inclusive of GST</li>
                <li>Payment is processed securely via Stripe</li>
                <li>Payment must be received in full before a report is generated</li>
                <li>Prices are subject to change without notice</li>
              </ul>
            </div>

            <div className="legal-section-block">
              <h2>4. Report Accuracy</h2>
              <p>Reports are generated from data held on government registers at the time of the search. While we strive for accuracy:</p>
              <ul>
                <li>We cannot guarantee the completeness or accuracy of data held on the PPSR</li>
                <li>We are not responsible for data that has not yet been registered</li>
                <li>Reports reflect information as at the date and time of the search</li>
                <li>A clear PPSR report does not guarantee a vehicle is free of all issues</li>
              </ul>
            </div>

            <div className="legal-section-block">
              <h2>5. Refund Policy</h2>
              <p>As reports are instantly generated from live government data, we are unable to offer refunds once a report has been delivered. If you believe there is a technical error, please contact us within 24 hours at <Link to="/contact">contact form</Link>.</p>
            </div>

            <div className="legal-section-block">
              <h2>6. Limitation of Liability</h2>
              <p>To the maximum extent permitted by Australian law, checkmycarhistory.com.au shall not be liable for any indirect, incidental, special, consequential or punitive damages arising from your use of our reports or services. Our total liability shall not exceed the amount paid for the specific report in question.</p>
            </div>

            <div className="legal-section-block">
              <h2>7. Acceptable Use</h2>
              <p>You agree to use our reports only for lawful purposes. You must not:</p>
              <ul>
                <li>Resell or redistribute our reports without written permission</li>
                <li>Attempt to access our systems without authorisation</li>
                <li>Use our services for fraudulent or unlawful purposes</li>
              </ul>
            </div>

            <div className="legal-section-block">
              <h2>8. Intellectual Property</h2>
              <p>All content on checkmycarhistory.com.au, including but not limited to text, graphics, logos, and software, is the property of checkmycarhistory.com.au or its content suppliers and is protected by Australian copyright laws.</p>
            </div>

            <div className="legal-section-block">
              <h2>9. Changes to Terms</h2>
              <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of the service after any changes constitutes acceptance of the new terms.</p>
            </div>

            <div className="legal-section-block">
              <h2>10. Governing Law</h2>
              <p>These terms are governed by the laws of New South Wales, Australia. Any disputes shall be subject to the exclusive jurisdiction of the courts of New South Wales.</p>
            </div>

            <div className="legal-section-block">
              <h2>11. Contact</h2>
              <p>Questions about these terms? Contact us via our <Link to="/contact">contact form</Link>.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
